import { AgTechButton } from "@agtech/web/components/Buttons/AgTechButtons";
import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from "@agtech/web/components/Menus/AgTechVerticalPopUpMenu";
import { SaleLot } from "@sales/data/lots/LotData";
import { useLotDataRemoveLotAction } from "@sales/data/lots/LotDataActions";
import LotSplitDialog from "../../dialogs/LotSplitDialog";
import LotDialog from "../../dialogs/LotDialog";

export type LotActionMenuProps = {
    lot: SaleLot
}

const LotActionMenu = (props: LotActionMenuProps) => {
    const lot = props.lot;
    const lotRemovalAction = useLotDataRemoveLotAction();

    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Lot">
                <LotDialog.Button lotId={props.lot.id} />
                <AgTechButton
                    text="Delete Lot"
                    icon="fas fa-times"
                    action={async e => {
                        await e.actions.executeDataActionInModal(lotRemovalAction, {
                            originalEntity: lot,
                            submittedEntity: lot
                        });
                    }}
                />
            </AgTechVerticalPopUpMenuSection>
            {lot.purchasePrice !== undefined && lot.purchasePrice > 0 && (
                <AgTechVerticalPopUpMenuSection header='Sale'>
                    <LotSplitDialog.Button lot={props.lot} />
                </AgTechVerticalPopUpMenuSection>
            )}
        </AgTechVerticalPopUpMenu>
    )
}

export default LotActionMenu